package link.erpango.quip

object Quip {
    lateinit var appComponents: AppComponents
}
